import {
  NewTypography,
  NewTextField,
  NewCheckBox,
  NewSelect,
} from "@bca/ui-library";
import styled from "styled-components";
import theme from "../../styles/theme";

export const StyledCompanyInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledTitle = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => (props.isMobile ? "22px" : "32px")};
  line-height: 29px;
  margin-bottom: ${(props) => (props.isMobile ? "1rem" : "3.5rem")};
  margin-top: 3.75rem;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-top: 2.81rem;
`;

export const StyledSubtitle = styled(NewTypography)`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
`;

export const StyledRequired = styled.span`
  color: ${theme.color.red};
  margin-left: 4px;
`;

export const StyledCheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => (props.isMobile ? "1.7rem" : "2.2rem")};
  margin-top: ${(props) => (props.isMobile ? "1.3rem" : "1.875rem")};
`;

export const StyledCheckbox = styled(NewCheckBox)``;

export const StyledInput = styled(NewTextField)``;

export const StyledNewSelect = styled(NewSelect)`
  width: 7.5rem;
  font-size: 3.28rem;
`;

export const StyledStateSelect = styled(NewSelect)``;
